import { ApiHttpService } from '../../services'
import router from '../../router'
export const ProductTypeModule = {
    namespaced: true,
    state: {
        data: {
            columns: [
                { label: 'Name', field: 'name', sort: 'asc', clickable: true, width: '220px' },
                { label: 'Arabic Name', field: 'arabic_name', sort: 'asc', width: '220px' },
                { label: 'Category', field: 'category_name', sort: 'asc', width: '180px' },
                { label: 'Department', field: 'department_name', sort: 'asc', width: '180px' },
                {
                    label: 'Status',
                    field: 'active',
                    sort: 'asc',
                    badge: true,
                    filters: [
                        { text: 'Active', value: '1' },
                        { text: 'Inactive', value: '0' },
                    ],
                    badgeFormatter: value => [true, 1, '1', 'true'].includes(value)
                        ? { label: 'Active', color: 'success' }
                        : { label: 'Inactive', color: 'secondary' },
                },
                { label: 'Sort Order', field: 'sort_order', sort: 'asc', width: '120px' },
            ],
            rows: [],
        },
        multipleSelection: [],
        length: 25,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading : false,
        getLoading : false,
        putLoading : false,
        postLoading : false,
        deleteLoading : false,
        form : {},
        initialFormData : {
            category_id: null,
            name: '',
            description: '',
            active: true,
            sort_order: 0,
        },
        formStatus: 'create'
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelRequest : (state) => {
            state.request.cancel()
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setColumns(state, payload) {
            state.data.columns = payload
        },
        setRows(state, payload) {
            state.data.rows = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
        setSelection: (state, payload) => {
            state.multipleSelection = payload
        },
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data.rows = []
        },
        LoadingFalse: (state) => {
            state.loading = false
        },

        setFormStatusCreate: (state) => {
            state.formStatus = 'create'
        },

        setFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        setFormRecord: (state, payload) => {
            state.form = payload
        },
        setGetloadingTrue: (state) => {
            state.getLoading = true
        },
        setGetloadingFalse: (state) => {
            state.getLoading = false
        },
        setFormData: (state, payload) => {
            state.form = payload
        },
        setPostLoadingTrue: (state) => {
            state.postLoading = true
        },
        setPostLoadingFalse: (state) => {
            state.postLoading = false
        },
        setPutLoadingTrue: (state) => {
            state.putLoading = true
        },
        setPutLoadingFalse: (state) => {
            state.putLoading = false
        },
    },
    actions : {
        async resetData({dispatch}, endpoint){
            dispatch('asyncGetData', endpoint)
        },
        async asyncGetData({ state, commit},endpoint) {

            const { loading, length, page, filters, searchTerm } = state
            return await new Promise((resolve, reject) => {
                if (loading === false) {
                    commit('setLoading', true)
                    commit('setRows', [])
                    const params = { length: length, page: page, term: searchTerm, filters: filters }

                    const configParams = {
                        req : "ProductTypeModule/req",
                        loadingTrue : "ProductTypeModule/loadingTrue",
                        addRequest : "ProductTypeModule/addRequest",
                        cancelRequest : "ProductTypeModule/cancelRequest",
                        clearOldRequest : "ProductTypeModule/clearOldRequest"
                    }

                    ApiHttpService.getRequest(endpoint, params, configParams).then((response) => {

                   
                        commit('setPage', response.data.current_page)
                        commit('setTotal', response.data.total)
                        commit('setRows', response.data.data)
                        commit('setLoading', false)
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                }
            })
        },

        async getRecord({ state, commit},obj) {
        
                    const { getLoading} = state
                    return await new Promise((resolve, reject) => {
                        if (getLoading === false) {
                            commit('setGetloadingTrue', true)
                            const initialFormData = {...JSON.parse(JSON.stringify(state.initialFormData)),...obj}
        
                            let defaultEndpoint = 'product-types/' + (obj.id || obj.hash);

                            ApiHttpService.getRequest(defaultEndpoint,{view : router.app._route.name}).then((response) => {
                                commit('setGetloadingFalse', false)
                                commit('setFormData', { ...initialFormData, ...(response.data.data || response.data) })
                                resolve(response.data)
                            }).catch(error => {
                                commit('setGetloadingFalse', false)
                                reject(error)
                            })
                        }
                    })
                },
        
        
        async storeRecord({ state, commit }, payload) {
            if (state.postLoading) {
                return Promise.reject(new Error('A Product Type request is already in progress.'))
            }

            commit('setPostLoadingTrue')

            try {
                const response = await ApiHttpService.postRequest('product-types', JSON.parse(JSON.stringify(payload)))
                return response.data
            } finally {
                commit('setPostLoadingFalse')
            }
        },

        async bulkStore(_, rows) {
            const response = await ApiHttpService.postRequest('product-types/bulk', { rows })
            return response.data
        },
        
        updateRecord({ state, commit }, payload) {
                    return new Promise((resolve, reject) => {
                        const putLoading = state.putLoading;
                        if (!putLoading) {
                            commit('setPutLoadingTrue')
                            const updatePayload = JSON.parse(JSON.stringify(payload))
                            const initialFormData = {...JSON.parse(JSON.stringify(state.initialFormData)),...payload}
                            ApiHttpService.update(`product-types`,updatePayload).then((response) => {
                                commit('setPutLoadingFalse')
                                let responseData = {...response.data.data};
                                const itemObject = {...initialFormData,...responseData}
                                commit('setFormData',itemObject)
                                resolve(responseData)
                            }).catch((error) => {
                                commit('setPutLoadingFalse')
                                reject(error)
                            })
                        }
            })
        },

        async deleteRecord(_, rows) {
            const tokens = rows.map(row => row.hash || row.id).filter(Boolean)
            const response = await ApiHttpService.deleteRequest('product-types', { tokens })
            return response.data
        },
    },
    getters: {
        rows: state => state.data.rows,
        data: state => state.data,
        columns: state => state.data.columns,
        selection : state => state.multipleSelection,
        loading : state => state.loading,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        searchTerm: state => state.searchTerm,
        filters: state => state.filters,
        req: state => state.request,
        initialFormObject: state => state.initialFormData,
        getLoading: state => state.getLoading,
        formData: state => state.form,
        formRecord: state => state.form,
        formStatus: state => state.formStatus,
        putLoading: state => state.putLoading,
        postLoading: state => state.postLoading,
        deleteLoading: state => state.deleteLoading,
    }
}



